import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex align-items-center position-relative settings-box-wrap for-navbar-mode",
  style: {"gap":"25px"}
}
const _hoisted_2 = {
  class: "d-flex align-items-center",
  style: {"gap":"5px","margin-top":"10px"}
}
const _hoisted_3 = {
  class: "d-flex align-items-center",
  style: {"gap":"5px","margin-top":"10px"}
}
const _hoisted_4 = {
  id: "switch",
  class: "switch-for-with-navbar"
}
const _hoisted_5 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "cursor position-relative active-wrap2",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setSidebar && _ctx.setSidebar(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["settings-box", { 'active-ltr': !_ctx.navbarMode }])
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("span", null, null, -1),
        _createElementVNode("span", null, null, -1),
        _createElementVNode("span", null, null, -1),
        _createElementVNode("span", null, null, -1),
        _createElementVNode("span", null, null, -1),
        _createElementVNode("span", null, null, -1)
      ]), 2),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("i", {
          class: _normalizeClass(["ri-checkbox-circle-fill position-relative top-1 fs-18 text-primary", { 'opacity-1': !_ctx.navbarMode, 'opacity-0': _ctx.navbarMode }])
        }, null, 2),
        _createElementVNode("i", {
          class: _normalizeClass(["ri-checkbox-blank-circle-line position-relative fs-18 text-light-40 position-absolute start-0 bottom-0", { 'opacity-0': !_ctx.navbarMode, 'opacity-1': _ctx.navbarMode }])
        }, null, 2),
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fw-semibold" }, "Sidebar", -1))
      ])
    ]),
    _createElementVNode("div", {
      class: "cursor position-relative active-wrap1",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setNavbar && _ctx.setNavbar(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["settings-box for-navbar", { 'with-navbar': _ctx.navbarMode }])
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("span", { class: "mx-auto start-0 rounded-top-0 rounded-bottom-3" }, null, -1),
        _createElementVNode("span", { class: "mx-auto start-0 rounded-bottom-0 rounded-top-3" }, null, -1)
      ]), 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", {
          class: _normalizeClass(["ri-checkbox-circle-fill position-relative top-1 fs-18 text-primary", { 'opacity-1': _ctx.navbarMode, 'opacity-0': !_ctx.navbarMode }])
        }, null, 2),
        _createElementVNode("i", {
          class: _normalizeClass(["ri-checkbox-blank-circle-line position-relative fs-18 text-light-40 position-absolute start-0 bottom-0", { 'opacity-0': _ctx.navbarMode, 'opacity-1': !_ctx.navbarMode }])
        }, null, 2),
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "fw-semibold" }, "Navbar", -1))
      ])
    ]),
    _createElementVNode("label", _hoisted_4, [
      _createElementVNode("input", {
        type: "checkbox",
        class: "position-absolute top-0 bottom-0 start-0 end-0 opacity-0 cursor",
        checked: _ctx.navbarMode,
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleNavbar && _ctx.toggleNavbar(...args))),
        id: "slider"
      }, null, 40, _hoisted_5),
      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "sliders round" }, null, -1))
    ])
  ]))
}